import { makeImageSizeSelector } from "@client/content/selectors";
import { globals } from "@client/globals";
import { connectCustom, joinDefined } from "@client/lib/misc";
import { getSettingValueSelector } from "@client/selectors";
import { type EntityRef } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { EMPTY_OBJECT } from "@common/lib/misc";
import Component, { type ImageProps } from "./component";
import { makeExtraAttributesSelector, makeSrcSelector, makeStyleSelector } from "./selectors";

type Props = EntityRef & {
  alt?: string;
  className?: string;
  isFixedSize?: boolean;
  size?: string;
  src: string;
  style?: React.CSSProperties;
  useMaxValues?: boolean;
};

export const makeImageContainer = (target: string, prefix?: string) => {
  const mapStateToProps = () => {
    const extraAttributesSelector = makeExtraAttributesSelector();
    const fitSelector = getSettingValueSelector(target, "fit", joinDefined(".", prefix, "image"));
    const sizeSelector = makeImageSizeSelector(target, prefix);
    const styleSelector = makeStyleSelector(target, prefix);
    const srcSelector = makeSrcSelector();

    return (state: AppState, { src, ...props }: Props): ImageProps => {
      const extraAttributes = globals.mode === "app" ? extraAttributesSelector(state, props) : EMPTY_OBJECT;
      const fit = fitSelector(state, props);
      const size = sizeSelector(state, props);

      return {
        ...props,
        ...extraAttributes,
        size: props.size ?? size,
        src: srcSelector(state, { src, size, fit }),
        style: styleSelector(state, props)
      };
    };
  };

  return connectCustom(mapStateToProps)(Component);
};
